<template>
   <div class="sort-dropdown">
      <button v-click-outside="hide" @click="toggleDropdown" :class="{focused: showDropdown}">
         {{pluralize(selected.text)}}
      </button>
      <div id='sort_list' v-if="showDropdown">
         <a v-for="option in options" :key="option.id" @click="showDropdown = false; selected = option; $emit('newOption', option.id)">
            {{pluralize(option.text)}}
         </a>
      </div>
   </div>
</template>


<script>
import BaseSortDropdown from './BaseSortDropdown';
export default {
   extends: BaseSortDropdown,
   data() {
      return {
         showDropdown: false,
         selected: this.options[0],
      }
   },

   props: {
      options: Array
   },

   methods: {
      toggleDropdown() {
         this.showDropdown = !this.showDropdown;
      },

      pluralize(text) {
         if (text[text.length-1] != 's' && text != 'audio') {
            text += 's';
         }
         return text;
      },

      handleOptionClick(option) {
         this.showDropdown = false;
         this.selected = option;
         this.$parent.$emit('new-option', option.id);
      },

      hide() {
         this.showDropdown = false;
      },
   },

   watch: {
      options() {
         this.selected = this.options[0];
      }
   }
}

</script>


<style lang="scss" scoped>
.sort-dropdown {
   position: relative;
   background: #fff;
   font-size: 10px;
   padding: 4px 2px;
   width: 190px;
   border-radius: 4px;
   color: #a7a7a7;
   border: 1px solid #a7a7a7;

   button {
      border: none;
      text-transform: uppercase;
      color: #a7a7a7;
      width: 100%;
      background-position: 95% center;
   }

   #sort_list {
      position: absolute;
      background: white;
      z-index: 20;
      width: 190px;
      top: 25px;
      left: 0px;
      border: 1px solid gray;
      border-radius: 5px;

      a {
         text-transform: uppercase;
         &:hover {
            background-color: #c0c0c0;
            color: $bard-gold;
         }
      }
   }
}

</style>